<template lang="pug">
  .container
    .title Groups:
      .title-action(@click='toggleAllGroups') {{ allGroupsSelected ? 'Deselect all' : 'Select all' }}
    .groups
      .group(v-for='licenseGroup in licenseGroupList' :key='licenseGroup.id')
        el-checkbox-group(v-model='assignees.appLicenseGroups' @change="onGroupChange")
          el-checkbox(:label='licenseGroup.id')
            | {{ licenseGroup.group.name }}
            .group-count ({{ licenseGroup.numUsers }})
            el-tag.app-access-label(v-if='licenseGroup.group.hasAppAccess' type="success") App access

    .title(:style="{position: 'relative'}") Specific users:
      fa-icon.tooltip-icon-p(icon="info-circle" size="xs" :style="{left: '106px',top: '5px'}" v-tooltip.top="{ content:'Start typing a name below to assign this programme to specific user(s) in addition to any groups you have assigned above.', classes:'ethos-tooltip'}")
    .search-user
      el-autocomplete(:fetch-suggestions="searchUsers" placeholder="Name or email address" v-model="searchUser"
        custom-item="user-suggestion" :trigger-on-focus="false" @select="onUserSelected")

    transition-group.users(name='el-fade-in')
      .selected-user(v-for='(user, userIndex) in assignees.users' :key='user.id')
        | {{ user.email }}
        .remove-user(@click='removeUser(userIndex)')
          icon(name="times" color='#666')

</template>

<script>
import Vue from "vue";
import _ from "lodash";
import { mapActions } from "vuex";

Vue.component("user-suggestion", {
  functional: true,
  render(h, ctx) {
    const user = ctx.props.item;
    return h("li", ctx.data, [
      h("div", { attrs: { class: "value" } }, [
        user.firstName,
        " ",
        user.lastName
      ]),
      h("div", { attrs: { class: "value" } }, [user.email])
    ]);
  },
  props: {
    item: { type: Object, required: true }
  }
});

export default {
  model: {
    prop: "assignees",
    event: "change"
  },
  props: {
    assignees: {
      type: Object,
      default: () => ({
        users: [],
        appLicenseGroups: []
      })
    }
  },
  data() {
    return {
      loading: false,
      licenseGroups: [],
      searchUser: ""
    };
  },
  computed: {
    appCodename() {
      return this.$route.params.app;
    },
    allGroupsSelected() {
      return (
        this.assignees.appLicenseGroups.length === this.licenseGroups.length
      );
    },
    licenseGroupList() {
      return _.orderBy(this.licenseGroups, lg => lg.group.hasAppAccess, [
        "desc"
      ]);
    }
  },
  methods: {
    ...mapActions({
      fetchGroups: "appLicenseGroups/fetch",
      fetchUsers: "users/fetchUsers"
    }),
    searchUsers(queryString, cb) {
      if (!queryString) {
        cb([]);
      }
      const params = { email__contains: queryString };
      this.fetchUsers({ params }).then(users => {
        const unassigned = _.differenceBy(users, this.assignees.users, "id");
        cb(unassigned);
      });
    },
    onUserSelected(user) {
      this.assignees.users.push(user);
      this.$emit("update:assignees", this.assignees);
    },
    onGroupChange() {
      this.$emit("update:assignees", this.assignees);
    },
    removeUser(index) {
      this.assignees.users.splice(index, 1);
      this.$emit("update:assignees", this.assignees);
    },
    selectAllGroups() {
      this.assignees.appLicenseGroups = this.licenseGroups.map(lg => lg.id);
      this.$emit("update:assignees", this.assignees);
    },
    deselectAllGroups() {
      this.assignees.appLicenseGroups = [];
      this.$emit("update:assignees", this.assignees);
    },
    toggleAllGroups() {
      this[this.allGroupsSelected ? "deselectAllGroups" : "selectAllGroups"]();
      this.$emit("update:assignees", this.assignees);
    }
  },
  mounted() {
    this.loading = true;
    this.fetchGroups({
      params: { app_license__app__codename: this.appCodename }
    }).then(data => {
      this.loading = false;
      this.licenseGroups = data;
    });
  }
};
</script>

<style scoped lang="scss">
.container {
  background: white;
}

.title {
  margin-bottom: 0px;
  font-weight: normal;
  padding-bottom: 5px;
  display: flex;
}

.title-action {
  flex: 0 0 auto;
  margin-left: auto;
  font-size: 13px;
  cursor: pointer;
  color: #666;
}

.groups {
  margin-bottom: 20px;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 3px;
}

.group {
  padding: 5px 0;
}

.users {
  margin-top: 10px;
  padding: 0 5px;
}

.selected-user {
  padding: 5px 0;
  display: flex;
  border-bottom: 1px solid #eee;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:last-child {
    border-bottom: 0;
  }
}

.group-count {
  font-size: 12px;
  color: #999;
  margin-left: 5px;
  display: inline-block;
}

.app-access-label {
  margin-left: 5px;
}

.remove-user {
  flex: 0 0 auto;
  margin-left: auto;
  cursor: pointer;
}
</style>
